( function( app ) {
  let ctaStackObserver = null;

  const COMPONENT = {
    init: function() {
      const $ctas = document.querySelector( '.navigation-one .primary-nav__mobile-ctas' );
      if ( $ctas ) {
        const syncCtaStackHeight = function() {
          document.documentElement.style.setProperty(
              '--mobileCtaStackHeight',
              $ctas.offsetHeight + 'px',
          );
        };
        syncCtaStackHeight();
        if ( window.ResizeObserver ) {
          ctaStackObserver = new ResizeObserver( syncCtaStackHeight );
          ctaStackObserver.observe( $ctas );
        }
        $( window ).on( 'resize orientationchange', syncCtaStackHeight );
      }

      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-one .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-one', COMPONENT );
} )( app );
